"use client";

import { motion, useReducedMotion } from "framer-motion";

import { useSecurityMockContent } from "@/hooks/security/useSecurityMockContent";

export const AuditLogVisual = () => {
  const prefersReducedMotion = useReducedMotion();
  const { auditEvents } = useSecurityMockContent();

  return (
    <div className="flex w-full flex-col">
      <div className="relative flex flex-col gap-0">
        <div
          className="absolute bottom-1 left-[7px] top-1 w-px bg-zinc-200 dark:bg-white/10"
          aria-hidden
        />
        {auditEvents.map(({ key, actor, action, time, highlight }, index) => (
          <motion.div
            key={key}
            className="relative flex gap-2.5 py-1.5"
            initial={{ opacity: 0, x: -4 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.08 }}
          >
            <div className="relative z-10 mt-1 flex flex-col items-center">
              <span
                className={`size-3 rounded-full border-2 ${
                  highlight
                    ? "border-zinc-500 bg-zinc-200 shadow-[0_0_10px_rgba(0,0,0,0.06)] dark:border-brand dark:bg-[#1a1c22] dark:shadow-[0_0_10px_rgba(255,197,57,0.4)]"
                    : "border-zinc-300 bg-white dark:border-white/20 dark:bg-[#14161c]"
                }`}
                aria-hidden
              />
            </div>
            <div
              className={`min-w-0 flex-1 rounded-lg border px-2 py-1.5 ${
                highlight
                  ? "border-zinc-300/90 bg-zinc-50 dark:border-brand/25 dark:bg-[#1a1c22]"
                  : "border-zinc-200/50 bg-white dark:border-white/[0.06] dark:bg-[#14161c]"
              }`}
            >
              <div className="flex items-start justify-between gap-2">
                <p className="text-[9px] font-semibold text-zinc-800 dark:text-white/85 sm:text-[10px]">
                  {actor}
                </p>
                <span className="shrink-0 font-mono text-[8px] tabular-nums text-zinc-400 dark:text-white/40 sm:text-[9px]">
                  {time}
                </span>
              </div>
              <p className="mt-0.5 text-[9px] leading-snug text-zinc-500 dark:text-white/50 sm:text-[10px]">
                {action}
              </p>
              {highlight && !prefersReducedMotion ? (
                <motion.div
                  className="mt-1 h-px bg-gradient-to-r from-zinc-400/60 to-transparent dark:from-brand/50"
                  animate={{ opacity: [0.4, 1, 0.4] }}
                  transition={{ duration: 2, repeat: Infinity }}
                />
              ) : null}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
